module.exports = __webpack_public_path__ + "img/sazerac.96e74bc4.jpg";